export const initialState = {
  showError: null,
  showPassword: false,
  domainError: null,
  loading: false,
  showConfirmPassword: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "setShowError":
      return { ...state, showError: action.value };
    case "setShowPassword":
      return { ...state, showPassword: action.value };
    case "setDomainError":
      return { ...state, domainError: action.value };
    case "setLoading":
      return { ...state, loading: action.value };
    case "setShowConfirmPassword":
      return { ...state, showConfirmPassword: action.value };
    default:
      return state;
  }
};
